var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mascot-alert",class:'scheme--' + _vm.scheme},[_c('div',{staticClass:"mascot-alert__img-wrap"},[_c('img',{staticClass:"mascot-alert__img",attrs:{"src":_vm.img,"alt":"Trading Mate Mascot"}})]),_c('div',{staticClass:"mascot-alert__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }